var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
function createArrayOfNumber(length) {
  return [...new Array(length + 1)].map((val, index) => index / length);
}
function withIntersectionObserver(BaseClass, defaultOptions = { threshold: createArrayOfNumber(100) }) {
  var _a, _b;
  return _b = class extends BaseClass {
    constructor(element) {
      super(element);
      this.$observer = new IntersectionObserver((entries) => {
        this.__callMethod("intersected", entries);
      }, {
        ...defaultOptions,
        ...this.$options.intersectionObserver
      });
      this.$on("mounted", () => {
        this.$observer.observe(this.$el);
      });
      this.$on("destroyed", () => {
        this.$observer.unobserve(this.$el);
      });
    }
  }, __publicField(_b, "config", {
    ...BaseClass.config,
    name: `${BaseClass.config.name}WithIntersectionObserver`,
    options: {
      ...((_a = BaseClass.config) == null ? void 0 : _a.options) || {},
      intersectionObserver: Object
    },
    emits: ["intersected"]
  }), _b;
}
export {
  withIntersectionObserver as default
};
